// extracted by mini-css-extract-plugin
module.exports = {"container":"LinkWithIcon_container__2juFc","icon":"LinkWithIcon_icon__3SBoA"};